import * as React from "react";
import {
  List, Datagrid, TextField, FunctionField, Show, SimpleShowLayout,
  useRecordContext,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { InfoGrid } from "../../components/InfoGrid";
import { TechInfo } from "../../components/ui";
import { UserRefField } from "../../components/ui";
import { fmtDateTime } from "../../utils/format";

// ContactController : GET /contact (liste admin) + POST /contact (envoi
// depuis les apps). Ni GET /{id}, ni PUT, ni DELETE, ni statut : écran en
// lecture seule, détail dépliable dans la liste (et fiche lue depuis la
// liste — getOneFromList).
// ContactMessage : id, userId, title, description, createdAt (epoch ms).

const fmtTs = (ms) => fmtDateTime(ms);


const MessageDetail = () => {
  const r = useRecordContext();
  if (!r) return null;
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>{r.title || "(sans objet)"}</Typography>
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{r.description || "—"}</Typography>
    </Box>
  );
};

const contactResource = {
  list: () => (
    <List sort={{ field: "createdAt", order: "DESC" }}>
      <Datagrid rowClick="expand" expand={<MessageDetail />} bulkActionButtons={false}>
        <FunctionField label="Date" render={(r) => fmtTs(r?.createdAt)} />
        <UserRefField source="userId" label="Utilisateur" />
        <TextField source="title" label="Objet" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show actions={false}>
      <SimpleShowLayout>
        <InfoGrid
          fields={[
            { label: "ID", source: "id", type: "mono" },
            { label: "Utilisateur", source: "userId", type: "mono" },
            { label: "Objet", source: "title" },
            { label: "Date", source: (r) => fmtTs(r?.createdAt) },
          ]}
        />
        <MessageDetail />
        <JsonField source="__all__" />
        <TechInfo />
        </SimpleShowLayout>
    </Show>
  ),
};

export default contactResource;
